module.exports = __webpack_public_path__ + "static/img/charles59_Japanese_young_fashion_model_white_background_bright__ffa2e8b4-e40c-4e56-ba1d-1fa33c7f068f.0e98980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/charles59_Japanese_young_fashion_model_white_background_bright__ffa2e8b4-e40c-4e56-ba1d-1fa33c7f068f.png
// module id = tgVo
// module chunks = 0